import React from 'react';

const Brother = ({ house }) => {
    return (
        <div>
            <h2>Brother</h2>
            <p><small>House: {house}</small></p>
        </div>
    );
};

export default Brother;